import Axios from "axios";
import {
    SET_PUR_CS_APPROVAL_REPORT,
    UNSET_PUR_CS_APPROVAL_REPORT,
} from "@/store/mutation-types";
import { getPurCSApprovalReport } from "@/store/api";

const state = {
    getPurCSApprovalReport: [],
};

const getters = {
    getPurCSApprovalReport(state) {
        return state.getPurCSApprovalReport;
    },
};

const mutations = {
    [SET_PUR_CS_APPROVAL_REPORT](state, data) {
        state.getPurCSApprovalReport = data;
    },
    [UNSET_PUR_CS_APPROVAL_REPORT](state) {
        state.getPurCSApprovalReport = [];
    },
};

const actions = {
    getPurCSApprovalReport({ commit }, params) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getPurCSApprovalReport, { params })
                .then((response) => {
                    commit(SET_PUR_CS_APPROVAL_REPORT, response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_PUR_CS_APPROVAL_REPORT);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};


